import { AnchorLink as Link } from "gatsby-plugin-anchor-links";
import React from "react";
import ContactFormModal from "./ContactFormModal";

function Footer({ addClass }) {
  return (
    <>
      <footer className="pz-footer">
        <div className="pz-footer__inner">
          <div className="pz-footer__grid">
            {/* ── Column 1: Brand ── */}
            <div>
              <Link to="/" aria-label="Prozo home">
                <img
                  src="/media/Prozo-Logo.png"
                  alt="Prozo"
                  className="pz-footer__brand-logo"
                />
              </Link>
              <p className="pz-footer__tagline">
                End-to-end supply chain solutions powering warehousing,
                fulfilment, and logistics across India.
              </p>
              <ul className="pz-footer__social">
                <li>
                  <a
                    href="https://www.linkedin.com/company/prozo"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pz-footer__social-link"
                    aria-label="LinkedIn"
                  >
                    <i className="mdi mdi-linkedin" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/prozodotcom"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pz-footer__social-link"
                    aria-label="Twitter"
                  >
                    <i className="mdi mdi-twitter" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/proship.by.prozo"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pz-footer__social-link"
                    aria-label="Facebook"
                  >
                    <i className="mdi mdi-facebook" />
                  </a>
                </li>
              </ul>
            </div>

            {/* ── Column 2: Solutions & Platform ── */}
            <div>
              <h4 className="pz-footer__heading">Solutions</h4>
              <ul className="pz-footer__links">
                <li><Link to="/warehousing">Warehousing</Link></li>
                <li><Link to="/logistics/surface-air-delivery">Freight & Logistics</Link></li>
                <li><Link to="/warehousing/quick-commerce">Quick Commerce</Link></li>
                <li><Link to="/packaging-material">Packaging Material</Link></li>
                <li><Link to="/warehousing/4pl-aggregation">4PL Aggregation</Link></li>
                <li><Link to="/hyperlocal-delivery">Hyperlocal Delivery</Link></li>
              </ul>
              <h4 className="pz-footer__heading">Platform</h4>
              <ul className="pz-footer__links">
                <li><Link to="/technology/warehouse-management-system">ProWMS</Link></li>
                <li><Link to="/technology/order-management-system">ProOMS</Link></li>
                <li><Link to="/technology/freight-management-system">ProSHIP</Link></li>
                <li><Link to="/technology/control-tower">Control Tower</Link></li>
              </ul>
            </div>

            {/* ── Column 3: Company & Resources ── */}
            <div>
              <h4 className="pz-footer__heading">Company</h4>
              <ul className="pz-footer__links">
                <li><Link to="/about-us/contact">How We Work</Link></li>
                <li><Link to="/why-end-to-end">Why Prozo</Link></li>
                <li><Link to="/about-us/our-clients">Our Clients</Link></li>
                <li><Link to="/about-us/pfn">Fulfilment Network</Link></li>
                <li><Link to="/about-us/case-study">Case Studies</Link></li>
                <li><Link to="/media">In the News</Link></li>
              </ul>
              <h4 className="pz-footer__heading">Resources</h4>
              <ul className="pz-footer__links">
                <li><Link to="/academy">Supply Chain Academy</Link></li>
                <li>
                  <a
                    href="https://blogs.prozo.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Blog
                  </a>
                </li>
                <li><Link to="/hyperlocal-delivery-planning">Hyperlocal Planning</Link></li>
              </ul>
            </div>

            {/* ── Column 4: Get in Touch ── */}
            <div>
              <h4 className="pz-footer__heading">Get in Touch</h4>
              <div className="pz-footer__contact-item">
                <i className="mdi mdi-map-marker" />
                <span>
                  Enkay Tower, Plot B&amp;B1, A Wing, 3rd Floor, Vanijya Nikunj,
                  Udyog Vihar Phase V, Gurugram, Haryana 122016
                </span>
              </div>
              <div className="pz-footer__contact-item">
                <i className="mdi mdi-phone" />
                <a href="tel:+919311847248">+91 93118 47248</a>
              </div>
              <div className="pz-footer__contact-item">
                <i className="mdi mdi-email" />
                <a href="mailto:sales@prozo.com">sales@prozo.com</a>
              </div>
              <button
                className="pz-footer__cta"
                data-toggle="modal"
                data-target="#contact"
              >
                Say Hello <i className="mdi mdi-arrow-right" />
              </button>
              <div className="pz-footer__badges">
                <span className="pz-footer__badge">
                  <i className="mdi mdi-shield-check" /> SOC 2 Type II
                </span>
                <span className="pz-footer__badge">
                  <i className="mdi mdi-shield-check" /> DPDP Compliant
                </span>
              </div>
            </div>
          </div>

          {/* ── Bottom Bar ── */}
          <hr className="pz-footer__divider" />
          <div className="pz-footer__bar">
            <p className="pz-footer__copyright">
              &copy; {new Date().getFullYear()} Prozo Integrated Logistics Pvt.
              Ltd. All rights reserved.
            </p>
            <ul className="pz-footer__legal">
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/toc">Terms & Conditions</Link></li>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
              <li><Link to="/compliance">Compliance</Link></li>
            </ul>
          </div>
        </div>
      </footer>

      <ContactFormModal />

      <div className="cookie-overlay p-4 d-none">
        <div
          className="d-flex align-items-center"
          style={{ justifyContent: "space-between" }}
        >
          <div className="mr-3">
            We use cookies on our website to see how you interact with it. By
            accepting, you agree to our use of such cookies.{" "}
            <Link to="/privacy-policy">Privacy Policy</Link>
          </div>
          <div>
            <button
              type="button"
              className="close-cookies"
              style={{
                background: "transparent",
                border: "1px solid #000",
                borderRadius: 3,
                color: "#000",
                fontSize: 12,
              }}
            >
              Close
            </button>
            <button
              className="accept-cookies"
              style={{
                background: "#000",
                border: 0,
                borderRadius: 3,
                color: "#fff",
                fontSize: 12,
              }}
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
      <button
        type="button"
        style={{ right: 80 }}
        className="btn btn-icon btn-soft-primary back-to-top"
        id="scrollTop"
      >
        <i data-feather="arrow-up" className="icons" />
      </button>
    </>
  );
}

export default Footer;
